import { render, staticRenderFns } from "./BasicDisplay.vue?vue&type=template&id=c66f9f2a&scoped=true"
var script = {}
import style0 from "./BasicDisplay.vue?vue&type=style&index=0&id=c66f9f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66f9f2a",
  null
  
)

export default component.exports